export const metatagizestawienia = {
  Page: {
    "meta-tagi": {
      Title:
        "SkiOne.pl ••• zestawienie ofert wczasów i wyjazdów narciarskich",
      Description:
        "SkiOne.pl ••• znajdź najlepsze oferty wyjazdów na narty, last minute na narty, ski pass i karnet w cenie, Austria, Włochy, Czechy, Słowacja, Tyrol, tanie wyjazdy na narty, zestawienie najlepszych wyjazdów na narty",
      Keywords: []
    }
  }
};
